// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YevX","controls":"styles_controls__1P566","charLimit":"styles_charLimit__1Hdjw","input":"styles_input__3q3vc","send":"styles_send__2MTmq"};